import React from "react";
import { Link } from "react-router-dom";
import { LegalPageLayout } from "../components/layout/LegalPageLayout";

const Compliance: React.FC = () => {
  return (
    <LegalPageLayout
      title="Compliance"
      description="Regulatory and compliance information for Setgo Innovations, Digistore Pay, SetGo, and Easy Jobs."
    >
      <h1 className="text-3xl font-bold text-secondary-900 mb-2">
        Compliance
      </h1>
      <p className="text-secondary-600 text-sm mb-8">
        Last updated: January 2025. Setgo Innovations Private Limited (CIN:
        U85499KL2025PTC092559).
      </p>

      <section className="space-y-6 text-secondary-700">
        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            1. Our Commitment
          </h2>
          <p>
            Setgo Innovations Private Limited is committed to operating
            Digistore Pay (Fintech), SetGo (Edutech), and Easy Jobs (Jobtech)
            in compliance with applicable Indian laws and regulations. We
            maintain robust internal controls, policies, and procedures to
            uphold legal and ethical standards.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            2. Regulatory Framework
          </h2>
          <p className="mb-2">Our operations align with:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>
              <strong>Company law:</strong> We are registered as Setgo
              Innovations Private Limited under CIN: U85499KL2025PTC092559 and
              comply with the Companies Act and related regulations.
            </li>
            <li>
              <strong>Financial services (Digistore Pay):</strong> Our payment
              and fintech solutions operate in line with Reserve Bank of India
              (RBI) guidelines and payment system regulations. We work with
              licensed payment aggregators and banks to ensure compliant
              transactions.
            </li>
            <li>
              <strong>Data protection:</strong> We handle personal and
              financial data in accordance with applicable data protection
              norms and our Privacy Policy.
            </li>
            <li>
              <strong>Education and employment:</strong> SetGo and Easy Jobs
              comply with relevant education and labour regulations where
              applicable.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            3. Anti-Money Laundering (AML) and KYC
          </h2>
          <p>
            For Digistore Pay and other services where we handle financial
            transactions or identity verification, we implement Know Your
            Customer (KYC) and Anti-Money Laundering (AML) measures as required
            by our partners and applicable law. We may collect identity and
            address proof and transaction records for compliance and fraud
            prevention.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            4. Security and Data Handling
          </h2>
          <p>
            We use industry-standard security measures to protect data. Access to
            sensitive information is restricted to authorised personnel. We
            retain data only as long as necessary for business, legal, or
            regulatory purposes.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            5. Partner and Third-Party Compliance
          </h2>
          <p>
            We work with regulated payment processors, banks, and service
            providers who maintain their own compliance programmes. Our
            agreements require them to adhere to applicable laws and standards.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            6. Reporting and Audits
          </h2>
          <p>
            We maintain records and cooperate with regulators and law
            enforcement when required by law. Internal and external audits may
            be conducted to verify compliance with our policies and applicable
            regulations.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold text-secondary-900 mb-2">
            7. Contact
          </h2>
          <p>
            For compliance-related queries or to report a concern, contact us
            at{" "}
            <a
              href="mailto:contact@setgo.in"
              className="text-primary-500 hover:underline"
            >
              contact@setgo.in
            </a>
            . Setgo Innovations Private Limited, headquartered in Kerala, India;
            CIN: U85499KL2025PTC092559.
          </p>
        </div>
      </section>

      <p className="mt-10 text-sm text-secondary-500">
        <Link to="/" className="text-primary-500 hover:underline">
          ← Back to home
        </Link>
      </p>
    </LegalPageLayout>
  );
};

export default Compliance;
